module.exports = __webpack_public_path__ + "static/media/socialy.b1cd6a79.svg";